var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovedicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 17.6803C14.7419 17.6803 18.1803 14.2419 18.1803 10.0003C18.1803 5.75877 14.7419 2.32031 10.5003 2.32031C6.25876 2.32031 2.82031 5.75877 2.82031 10.0003C2.82031 14.2419 6.25876 17.6803 10.5003 17.6803ZM14.0591 8.75914C14.434 8.38423 14.434 7.77639 14.0591 7.40149C13.6842 7.02659 13.0764 7.02659 12.7015 7.40149L9.54031 10.5627L8.29913 9.32149C7.92423 8.94659 7.31639 8.94659 6.94149 9.32149C6.56659 9.69639 6.56659 10.3042 6.94149 10.6791L8.86149 12.5991C9.23639 12.974 9.84423 12.974 10.2191 12.5991L14.0591 8.75914Z",
    fill: "#17C964"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedicon);
export default __webpack_public_path__ + "static/media/approvedicon.34a76fb1eaacf190dfd620d9420a7ea1.svg";
export { ForwardRef as ReactComponent };